import * as React from "react";

function SvgHeading4(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M7.5 12.5H6v-4H1.9v4H.5v-9h1.4v3.7H6V3.5h1.4l.1 9zM15.5 10.5h-1.2v2h-1.4v-2h-4V9.4l4-5.9h1.4v5.8h1.2v1.2zm-2.6-1.2V7.1c0-.8 0-1.5.1-2-.1.3-.3.6-.5 1l-2.2 3.2h2.6z" /></svg>;
}

export default SvgHeading4;